import { Switch as HeadlessUISwitch } from "@headlessui/react";

interface SwitchProps {
  isChecked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const Switch = ({ isChecked, onChange, disabled }: SwitchProps) => {
  return (
    <HeadlessUISwitch
      checked={disabled ? false : isChecked}
      onChange={onChange}
      disabled={disabled}
      // State is expressed with variants rather than by picking classes in JS,
      // so nothing here depends on the order the classes are merged in.
      className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-400 transition-colors duration-200 ease-in-out disabled:cursor-not-allowed disabled:bg-gray-200 data-[checked]:bg-yellow-400"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </HeadlessUISwitch>
  );
};

export default Switch;
